export default {
  // 获取登录用户信息
  getLoginUserInfo: {
    url: "/webservice/rest/server.php",
    wsfunction: "core_webservice_get_site_info"
  },
  // 获取课程信息
  courseInfo: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_mini_get_courses_by_course_id"
  },
  // 获取课程模块信息
  courseContent: {
    url: "/webservice/rest/server.php",
    wsfunction: "core_course_get_contents"
  },
  // 获取课程测验信息
  quizList: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_quiz_get_quizzes_by_courses"
  },
  // 获取courseelf模块信息
  getCourseelfInfo: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_courseelf_get_courseelfs_by_id"
  },
  // 获取模块组情况
  getModuleGroup: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_get_module_group"
  },
  // 编辑测验
  editQuiz: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_edit_quiz"
  },
  // 判断测验是否可编辑题目
  quizCanEditQuestion: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_quiz_can_edit_question"
  },
  // 获取课堂分类
  getGalleriesByCourseelf: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_courseelf_get_galleries_by_courseelf"
  },
  // 获取galler文件
  getFilesByGallery: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_courseelf_get_files_by_gallery"
  },
  // 更新galler文件
  updateGallery: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_courseelf_update_gallery"
  },
  // 更新galler文件
  updateFile: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_courseelf_update_file"
  },
  // 获取测验问题ID列表
  getQuestionIds: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_get_quiz_questionids"
  },
  // 获取测验问题详细信息
  getQuizQustionDetail: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_get_quiz_question_detail"
  },
  // 测验结束
  setQuizEnd: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_set_quiz_end"
  },
  // 测验延时
  setQuizDelay: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_set_quiz_delay"
  },
  // 测验延时
  getTimestamp: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_mini_get_timestamp"
  },
  // 获取考勤二维码
  getAttendanceQrcode: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_get_attendance_qrcode"
  },
  // 获取考勤用户信息
  getAttendanceInfo: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_get_attendance_info"
  },
  // 获取投屏文件
  getGalleryFiles: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_courseelf_get_files_by_gallery"
  },
  // 获取用户列表
  getUsersByCourseid: {
    url: "/webservice/rest/server.php",
    wsfunction: "core_enrol_get_enrolled_users"
  },
  // 通过课程id获取讨论区
  getForumsByCourseids: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_forum_get_forums_by_courses"
  },
  // 获取讨论区话题
  getForumDiscussions: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_forum_get_forum_discussions_paginated"
  },
  // 编辑讨论区
  editForum: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_edit_forum"
  },
  // 获取帖子回复列表(moodle 4.x)
  getForumDiscussionPosts: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_forum_get_discussion_posts"
  },
  // 获取投票结果
  getChoiceResult: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_choice_get_choice_results"
  },
  // 获取投票选项
  getChoiceOptions: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_choice_get_choice_options"
  },
  // 通过courseId获取投票列表
  getChoiceByCourseId: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_choice_get_choices_by_courses"
  },
  // 更新活动状态
  updateModule: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_update_module"
  },
  // 删除讨论区话题
  deleteDiscussionPost: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_mini_delete_forum_discussion"
  },
  // 上传文件
  uploadFile: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_mini_post_upload_file"
  },
  // 添加gallery文件
  addGallery: {
    url: "/webservice/rest/server.php",
    wsfunction: "mod_courseelf_add_gallery"
  },
  // 获取在线课堂
  getOnlineCourses: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_get_online_courses"
  },

  // 下发投屏指令
  sendMessage: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_send_message"
  },
  // 推送活动
  setLog: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_set_log"
  },
  // 结束授课
  sendFinishTeaching: {
    url: "/webservice/rest/server.php",
    wsfunction: "local_miniprogram_elf_send_finish_teaching"
  }
};
